import React from 'react';
import { Phone, Mail, MapPin, Facebook, ArrowUp, Shield } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quickLinks = [
    { name: 'Acasă', href: '#acasa' },
    { name: 'Despre Noi', href: '#despre' },
    { name: 'Servicii', href: '#servicii' },
    { name: 'Portofoliu', href: '#portofoliu' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Contact', href: '#contact' },
  ];

  const services = [
    'Hidroizolații Acoperișuri',
    'Hidroizolații Terase',
    'Hidroizolații Fundații',
    'Hidroizolații Balcoane',
    'Mentenanță Acoperișuri',
    'Consultanță Gratuită',
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url(${companyInfo.logo})`,
          backgroundSize: '400px',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>

      {/* Main footer content */}
      <div className="container mx-auto px-6 pt-16 pb-8 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Company info */}
          <div className="lg:col-span-1">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-16 w-auto mb-6"
            />
            <p className="text-slate-400 mb-6 leading-relaxed">
              Specialiști în hidroizolații profesionale din Iași. Protejăm construcțiile dumneavoastră cu materiale de calitate superioară.
            </p>
            <div className="flex items-center gap-3">
              <a
                href={companyInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center hover:bg-blue-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Link-uri Rapide</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-cyan-400 transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Servicii</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('#servicii')}
                    className="text-slate-400 hover:text-cyan-400 transition-colors text-left"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-slate-400 hover:text-cyan-400 transition-colors"
                >
                  <Phone size={18} />
                  <span>{companyInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-slate-400 hover:text-cyan-400 transition-colors"
                >
                  <Mail size={18} />
                  <span className="lowercase">{companyInfo.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={`https://maps.google.com/?q=${encodeURIComponent(companyInfo.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-slate-400 hover:text-cyan-400 transition-colors"
                >
                  <MapPin size={18} className="flex-shrink-0 mt-1" />
                  <span>{companyInfo.address}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-slate-800 mb-8"></div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-slate-500 text-sm text-center md:text-left">
            <p>&copy; {new Date().getFullYear()} {companyInfo.name}. Toate drepturile rezervate.</p>
            <p className="mt-1">CUI: {companyInfo.cui}</p>
          </div>

          {/* Admin link */}
          <div className="flex items-center gap-6">
            <a
              href="/admin"
              className="text-slate-600 hover:text-slate-400 text-sm transition-colors"
            >
              Admin
            </a>
            <button
              onClick={scrollToTop}
              className="w-10 h-10 rounded-xl bg-blue-600 hover:bg-blue-500 flex items-center justify-center transition-colors"
              aria-label="Scroll to top"
            >
              <ArrowUp size={18} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
